export const addNumberDotSeparator = (number: number) => number.toLocaleString('de', { maximumFractionDigits: 0 })
